/** The breakpoint from CSS **/
export const breakpoint = 985;

/**
 * Returns true if the window width is strictly less than the breakpoint.
 */
export function isMobile(): boolean {
    return window.innerWidth < breakpoint;
}

/**
 * Returns true if the window width is less than or equal to the breakpoint.
 */
export function isMobileIncludingBreakpoint(): boolean {
    return window.innerWidth <= breakpoint;
}
